import React from 'react';

const HeadMeta = ({ postData }) => {
  const canonicalUrl = postData?.seo?.canonical || false;

  return (
    <>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <meta name="google-site-verification" content="D0jeZBPgW-Lt1BBLmazM-mzdlF3aPICJhZiFfeGj9Lc"/>
    </>
  );
};

export default HeadMeta;
